jQuery(document).ready(function () {
    jQuery('.accordion .accordion__header .accordion__link, .accordion .accordion__header .accordion__button').click(function () {
        if (jQuery(this).closest('[data-accordion]').hasClass('is-open')) {
            closeAccordion(jQuery(this).closest('[data-accordion]'));
        } else {
            openAccordion(jQuery(this).closest('[data-accordion]'));
        }
    });
});

function openAccordion($el) {
    closeAccordion($el.closest('[data-accordions]').find('.is-open[data-accordion]'));
    $el.addClass('is-open').find('.accordion__content').slideDown();
}
function closeAccordion($el) {
    $el.removeClass('is-open').find('.accordion__content').slideUp();
}